// Lightweight confetti — no canvas, just CSS animation.

const COLORS = ['#6C5CE7', '#00CECE', '#00B894', '#FDCB6E', '#FF6B6B', '#8B7FF5'];

export function fireConfetti({ count = 60, duration = 2500 } = {}) {
  const wrap = document.createElement('div');
  wrap.className = 'confetti';
  for (let i = 0; i < count; i++) {
    const piece = document.createElement('div');
    piece.className = 'confetti-piece';
    const color = COLORS[Math.floor(Math.random() * COLORS.length)];
    const left = Math.random() * 100;
    const delay = Math.random() * 0.5;
    const dur = duration + Math.random() * 1000;
    const rotate = Math.random() * 360;
    const size = 6 + Math.random() * 8;
    piece.style.cssText = `
      left:${left}%;
      top:-10vh;
      width:${size}px;
      height:${size}px;
      background:${color};
      transform:rotate(${rotate}deg);
      animation-delay:${delay}s;
      animation-duration:${dur}ms;
      border-radius:${Math.random() < 0.5 ? '50%' : '2px'};
    `;
    wrap.appendChild(piece);
  }
  document.body.appendChild(wrap);
  setTimeout(() => wrap.remove(), duration + 1000);
}

if (typeof window !== 'undefined') window.fireConfetti = fireConfetti;
